import {
  apiRequest,
  gradeDetail,
  updatePresence,
} from "../../../../../services/adapters/kepegawaian/revisiTunjanganKhususService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      updatePresence,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      gradeDetail,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
